import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_public")({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <main>
      <PublicNavbar />
      <div className="flex h-full p-4 md:p-6 max-w-[1600px] w-full mx-auto">
        <Outlet />
      </div>
    </main>
  );
}

const PublicNavbar = () => {
  return (
    <header className="flex sticky top-0 bg-background h-16 max-w-[1600px] w-full mx-auto shrink-0 items-center justify-between gap-2 border-b px-4 z-40">
      <a
        href="https://inboxdoctor.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2"
      >
        <img
          src="/id-logo.png"
          alt="InboxDoctor"
          className="size-8 md:size-10 rounded-md"
        />
        <div className="flex flex-col whitespace-nowrap">
          <img
            src="/id-logo-text.png"
            alt="InboxDoctor"
            className="max-w-[90px] md:max-w-[120px]"
          />
        </div>
      </a>
      <div className="flex items-center gap-2">
        <Link to="/signin">
          <Button variant="outline">Login</Button>
        </Link>
        <Link to="/sign-up">
          <Button>Sign Up</Button>
        </Link>
      </div>
    </header>
  );
};
